import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import './CheckEmail.scss';
import Logo2 from '../../../components/Logo/Logo2';


const EmailVerified = ({ redirectTime = 10 }) => {
    document.title = 'Email Verified | DB Design';

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get('error');

    const [seconds, setSeconds] = useState(redirectTime);

    if (errorParam) {
        history.push('/error');
    }

    useEffect(() => {
        if (seconds > 0) {
            const timer = setInterval(() => {
                setSeconds(prevSeconds => prevSeconds - 1);
            }, 950);
            return () => clearInterval(timer);
        } else {
            history.push('/diagrams');
        }
    }, [seconds, history]);

    return (
        <div className="check-email-box">
            <Logo2 />
            <div className='check-email verified'>
                <svg width="62px" height="62px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <circle cx="12" cy="12" r="10" stroke="rgb(241, 241, 241)" strokeWidth="1.25"></circle>
                        <path d="M8.5 12.5L10.5 14.5L15.5 9.5" stroke="rgb(241, 241, 241)" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"></path>
                    </g>
                </svg>

                <div className="check-email-title verified">Email Verified</div>

                <div className='check-email-text-wrap verified'>
                    <p className="check-email-text">Your email was successfully verified.</p>
                </div>

                <a href="/diagrams" className="check-email-action verified">
                    <span>Continue</span>
                </a>

                <div className='check-email-text-wrap-bottom'>
                    <p className="check-email-text-bottom verified">Redirect to the app in {seconds} seconds</p>
                </div>

            </div>
        </div >
    );
};

export default EmailVerified;
